export default "__VITE_ASSET__BDaa$qwH__"